'use client';

import { clientLogProtobuf } from '@weberus/client-tracker/utils';
import { useEffect } from 'react';
import { LeisureListPageLog } from '@/app/_shared/protobuf-log/clientlogs';

interface ClientLoggerProps {
  logMeta: LeisureListPageLog.ListName.View;
}

export const ClientLogger = ({ logMeta }: ClientLoggerProps) => {
  useEffect(() => {
    clientLogProtobuf?.(LeisureListPageLog.ListName.view, logMeta)();
  }, []);

  return null;
};
